import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const IconAlertCircleFilled: React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M13 13a1 1 0 0 1-2 0V8a1 1 0 0 1 2 0v5Zm-1 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0-15C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z"
      fill={props.fill || 'currentColor'}
    />
  </SvgIcon>
);

export default IconAlertCircleFilled;
